//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.fragment.selections

import blazern.lexisoup.graphql.model.type.GraphQLString
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CompiledSelection
import com.apollographql.apollo.api.notNull
import kotlin.collections.List

public object SentenceFieldsSelections {
  public val __root: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "text",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledField.Builder(
          name = "langIso3",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledField.Builder(
          name = "source",
          type = GraphQLString.type.notNull()
        ).build()
      )
}
